import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {translate} from 'views/module';

const ContentView = (props) => {
  const bioQuestion = props.bioQuestion;

  const {questionData} = bioQuestion;

  return (
    <Typography variant="body1">
      {questionData.value || translate('caregiver.CaregiverDetail.Biography.Questions.Empty')}
    </Typography>
  );
};

ContentView.propTypes = {
  bioQuestion: PropTypes.shape({
    bioQuestionId: PropTypes.string.isRequired,
    questionData: PropTypes.shape({
      value: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ContentView;
